var _path, _path2, _ellipse, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 133,
    viewBox: "0 0 323 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.467 77.5928L322.001 91.9583M198.467 77.5928L185.691 108.707M198.467 77.5928L100.485 1M322.001 91.9583L309.225 123.072L185.691 108.707M322.001 91.9583L223.91 15.6292L100.485 1M185.691 108.707L87.709 32.1137L100.485 1",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.658 99.5442V131.798M115.658 99.5442L158.89 87.383M115.658 99.5442L58.329 83.4173M115.658 131.798L1 99.5442V67.2904M115.658 131.798L194.603 109.87M1 67.2904L98.1147 40.2031M1 67.2904L58.329 83.4173M58.329 83.4173L77.4386 78.4508M115.658 54.7336V59.746M144.479 76.6627L128.189 72.059",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.816,
    cy: 70.6821,
    rx: 25.3553,
    ry: 12.8159,
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1152 66.6377L101.875 71.6501L113.152 73.5297",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.172 72.7914C128.259 73.4512 128.172 75.451 128.172 76.6293C128.172 84.1147 116.82 90.1828 102.817 90.1828C88.8138 90.1828 77.4619 84.1147 77.4619 76.6293C77.4619 75.6487 77.4115 72.424 77.4619 71.6504",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStImg1);
export default __webpack_public_path__ + "static/media/st-img-1.e52ca4f901366e35e6a742215619c2ce.svg";
export { ForwardRef as ReactComponent };